import {SALESFORCE_ENDPOINTS} from '../configs/store'

/**
 * Determines endpoints for Pardot Form Handlers to submit to.
 * Uses details from the `Shopify` object that shopify injects into the window to get all the data it needs.
 *
 * @returns Object
 */
export function getSalesforceEndpoints() {
  const {country, locale, theme, shop} = window.Shopify

  const isStagingOrTest = [`test`, `staging`].some(phrase => shop.includes(phrase))
  const isPublishedTheme = theme.role === `main`
  const mode = (isStagingOrTest || !isPublishedTheme) ? `development` : `production`

  return SALESFORCE_ENDPOINTS[country][`locales`][locale][mode]
}

